import { css } from "@emotion/react";
import { handleColorStatus } from "helpers/showStatusText";
import { theme } from "styles/theme";

export const TableBettingRecordStyle = {
  wrapper: css`
    width: 100%;
    margin-bottom: 1rem;
    border: 1px solid #ddd;

    border-collapse: collapse;

    th {
      padding: 0.5rem;
      text-align: left;
      border: 1px solid #ddd;

      font-size: 14px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;

      color: ${theme.colors.black};
    }

    td {
      padding: 0.5rem;
      color: #000;
      text-align: left;
      border: 1px solid #ddd;

      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px;
    }
  `,

  item: css``,

  colorText: (status: number) => css`
    td {
      color: ${handleColorStatus(status)};
    }
  `,

  flex: css`
    flex: 0.8;
  `,
};
